export enum RequestMetricResult {
  SEND = 'requestSend',
  SUCCESS = 'requestSuccess',
  ERROR = 'requestError'
}
